var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsCloudformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77302 10.6822L2.87502 10.7932L8.02728 12.1929L8.05063 11.3253L4.44219 10.4574L4.26561 10.3964L2.77302 10.6822Z",
    fill: "#B7CA9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2268 10.6822L7.96484 12.3655L7.94919 11.3253L11.5576 10.4574L11.7148 10.2878L13.2268 10.6822Z",
    fill: "#B7CA9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94919 4.73594L11.5576 5.54191L13.1445 5.46976L13.2268 5.31734L8.19922 3.58298L7.94919 4.73594Z",
    fill: "#3C4929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44219 10.4574L2.77302 10.6822L2.72656 10.5162V5.49223L2.77302 5.31734L4.28127 5.42484L4.44219 5.54209L4.44219 10.4574Z",
    fill: "#759C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05063 4.73594L4.44219 5.54209L2.77302 5.31734L2.83592 5.22268L8.02728 3.8067L8.05063 4.73594Z",
    fill: "#3C4929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99278 1L2 3.89896L2.00286 12.1026L7.99278 15L8.08203 14.8701V1.16846L7.99278 1ZM6.24041 11.6797L2.77302 10.6822L2.77302 5.31734L6.24041 4.32052V11.6797ZM11.5576 10.4574L13.2268 10.6822L13.3203 10.5238V5.46989L13.2268 5.31734L11.5576 5.54191V10.4574Z",
    fill: "#4B612C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99278 15L13.9971 12.1026L14 3.89906L7.99278 1V15ZM9.75936 4.3204L13.2268 5.31734V10.6822L9.75936 11.6795V4.3204Z",
    fill: "#759C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudformation);
export default __webpack_public_path__ + "static/media/aws_cloudformation.0f5aacf6c9414ef7942ae4332a8e38ff.svg";
export { ForwardRef as ReactComponent };